export default function ArticleController() {

}